import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'addressFormatter'
})
export class AddressFormatterPipe implements PipeTransform {

  transform(address: any): string {
    if (!address) {
      return '';
    }

    const parts: string[] = [];

    if (address.line1) {
      parts.push(address.line1);
    }
    if (address.line2) {
      parts.push(address.line2);
    }
    if (address.town) {
      parts.push(address.town);
    }
    if (address.city) {
      parts.push(address.city);
    }
    if (address.postcode) {
      parts.push(address.postcode);
    }
    if (address.country) {
      parts.push(address.country);
    }

    return parts.join('\n');
  }

}
